module.exports = __webpack_public_path__ + "img/EC.a399c194.svg";